import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import SocialMediaLink from "../social-media-link/social-media-link";
import styles from "./social-media-link-list.module.css";
var SocialMediaLinkList = function(param) {
    var links = param.links;
    return /*#__PURE__*/ _jsx("ul", {
        className: styles.list,
        children: links.map(function(props) {
            return /*#__PURE__*/ _jsx(SocialMediaLink, _object_spread({}, props), props.name);
        })
    });
};
export default SocialMediaLinkList;
